<template lang="pug">
  .b2b-page-createcover
    b2b-steps(
      :steps='steps',
      :active='active',
      @update='nextStep')

    keep-alive
      component(:is='returnComponent', @update='nextStep')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bSteps from '@/components/B2bSteps'
import B2bCreateCover from '@/views/tareaspendientes/createcover/B2bCreateCover'
import B2bSendCover from '@/views/tareaspendientes/createcover/B2bSendCover'

export default {
  name: 'b2b-page-createcover',

  data () {
    return {
      active: 0
    }
  },

  computed: {
    steps () {
      return [
        { title: this.$t('pendingtask.createcover.cover.steps.creation') },
        { title: this.$t('pendingtask.createcover.cover.steps.send') }
      ]
    },
    ...mapGetters([
      'invoiceNoteIdsPendingTask',
      'hasCoverPendingTask'
    ]),
    returnComponent () {
      let component
      switch (this.active) {
        case 0:
          component = 'b2b-create-cover'
          break
        case 1:
          component = 'b2b-send-cover'
          break
      }
      return component
    }
  },

  async beforeRouteLeave (to, from, next) {
    // Comprobamos si estamos saliendo fuera del modulo de crear caratula.
    // Si salimos, borramos de sesión los ids  de la facturas y la validacion de si existe la factura
    if (to.name !== 'b2b-page-create-cover') {
      if (this.invoiceNoteIdsPendingTask) await this.invoiceNoteIdsPendingTaskState({})
      if (this.hasCoverPendingTask) await this.hasCoverPendingTaskState(false)
    }
    next()
  },

  components: {
    B2bSteps,
    B2bCreateCover,
    B2bSendCover
  },

  methods: {
    ...mapActions([
      'invoiceNoteIdsPendingTaskState',
      'hasCoverPendingTaskState'
    ]),

    nextStep: function (newActive) {
      switch (newActive) {
        case 0:
          this.active = newActive
          break
        case 1:
          if (this.hasCoverPendingTask) {
            this.active = newActive
          }
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
